import { render, staticRenderFns } from "./commerce.vue?vue&type=template&id=868be9e4&scoped=true"
import script from "./commerce.vue?vue&type=script&lang=js"
export * from "./commerce.vue?vue&type=script&lang=js"
import style0 from "./commerce.vue?vue&type=style&index=0&id=868be9e4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868be9e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('868be9e4')) {
      api.createRecord('868be9e4', component.options)
    } else {
      api.reload('868be9e4', component.options)
    }
    module.hot.accept("./commerce.vue?vue&type=template&id=868be9e4&scoped=true", function () {
      api.rerender('868be9e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingCampaign/commerce.vue"
export default component.exports